<template>

  <div>
    <div class="form-group">
      <div class="row mb-1" v-if="value.type !== 'forward' && (value.to && value.to.length)">
        <label class="col-sm-2 col-form-label">Para</label>
        <div class="col-sm-10">

          <div class="d-flex mb-1">
            <div class="flex-grow-1">
              <div class="form-control-plaintext">{{ to.join(', ') }}</div>
            </div>
            <div>
              <button type="button" class="btn btn-sm btn-light" @click="showBcc=!showBcc" v-if="!enableShowBcc">CC/BCC</button>
            </div>
          </div>

        </div>
      </div>
      
      <div class="row mb-1" v-if="value.type === 'forward'">
        <label class="col-sm-2 col-form-label">Para</label>
        <div class="col-sm-10">

          <div class="d-flex mb-1">
            <div class="flex-grow-1">
              <selectize-multiple-email v-model="value.to" :opts="[]"></selectize-multiple-email>
              <ValidateMessage :error="validateErrors.to" />
            </div>
            <div>
              <button type="button" class="btn btn-sm btn-light" @click="showBcc=!showBcc" v-if="!enableShowBcc">CC/BCC</button>
            </div>
          </div>
          
        </div>
      </div>
      
      <div class="row mb-1" v-if="showBcc">
        <label class="col-sm-2 col-form-label">CC</label>
        <div class="col-sm-10">
          <selectize-multiple-email v-model="value.cc" :opts="[]"></selectize-multiple-email>
          <ValidateMessage :error="validateErrors.cc" />
        </div>
      </div>
      
      <div class="row" v-if="showBcc">
        <label class="col-sm-2 col-form-label">BCC</label>
        <div class="col-sm-10">
          <selectize-multiple-email v-model="value.bcc" :opts="[]"></selectize-multiple-email>
          <ValidateMessage :error="validateErrors.bcc" />
        </div>
      </div>
    </div>

    <div class="input-group">
      <input class="form-control" :placeholder="$t('Subject')" v-model="value.subject">
      <div class="input-group-append">
        <templatemail-select
          @setTemplate="setTemplate">
          </templatemail-select>
      </div>
    </div>
    <ValidateMessage :error="validateErrors.subject" />

    <div class="form-group">
      <textarea-editable
        v-model="value.body"
        editor-model="html"
        :enable-link="true"
        :enable-img="true"
        :placeholder="$t('Message')"></textarea-editable>
      <ValidateMessage :error="validateErrors.body" />
    </div>

    <div class="mb-3">
      <input-media 
        v-model="value.attachments_media" 
        :multiple="true"
        btClass="btn btn-sm btn-light">
        <i class="fas fa-paperclip" /> {{ $t('Attach') }}
        </input-media>
      <ValidateMessage :error="validateErrors.attachments_media" />
    </div>
    
    <div class="form-group">
      <div class="row">
        <label class="col-sm-3">{{ $t('Send when') }}:</label>
        <div class="col-sm-9">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="send_type"
              id="send_type1"
              value="immediately"
              v-model="value.send_type">
            <label class="form-check-label" for="send_type1">
              {{ $t('Immediately') }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="send_type"
              id="send_type2"
              value="schedule"
              v-model="value.send_type">
            <label class="form-check-label" for="send_type2">
              {{ $t('Schedule') }}
            </label>
          </div>
          <ValidateMessage :error="validateErrors.send_type" />

          <div
            class="mt-3"
            v-if="value.send_type === 'schedule'">
            <DelayForm
              v-model="value.send_at" />
            <ValidateMessage :error="validateErrors.send_at" />
          </div>

        </div>
      </div>
    </div>

    <div :class="{'box-loading': loading}">
      <button
        type="submit"
        class="btn btn-primary"
        @click="saveEmail(value)">{{ $t('Send') }}</button>
      <button
        v-if="value.type"
        type="submit"
        class="btn btn-light"
        @click="cancelEmail()">{{ $t('Cancel') }}</button>
    </div>

  </div>

</template>

<script>
import TemplatemailSelect from '@/components/Parts/TemplatemailSelect'
import SelectizeMultipleEmail from '@/components/Fields/SelectizeMultipleEmail'
import InputMedia from '@/components/Fields/InputMedia'
import Formsave from '@/utils/Formsave'
import DelayForm from '@/components/Parts/DelayForm'

export default {
  name: 'EmailForm',
  components: {
    TemplatemailSelect,
    SelectizeMultipleEmail,
    InputMedia,
    DelayForm
  },
  props: [
    'initValue'
  ],
  data () {
    return {
      validateErrors: false,
      loading: false,
      value: this.defaultValues(this.initValue),
      showBcc: false,
      formsave: null
    }
  },
  computed: {
    to () {
      return this.value.to.map((v) => {
        return v.name === v.email ? v.email : v.name + ' <' + v.email + '>'
      })
    },
    enableShowBcc () {
      return (this.value.cc && this.value.cc.length) || (this.value.bcc && this.value.bcc.length)
    }
  },
  created () {
    this.showBcc = this.enableShowBcc

    this.formsave = Formsave.sync(this, 'CandidateEmail', [this.value.candidate_id, this.value.type, this.value.parent_email_id], 'value', (data) => {
      return data.body || data.subject
    })
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        send_type: 'immediately'
      }, values)
    },
    /*
    saveEmail
    */
    saveEmail (data) {
      this.loading = true

      this.$store
      .dispatch('createEmail', data)
      .then((result) => {
        this.loading = false
        this.$emit('created', result.data)
        this.resetEmail()
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    cancelEmail () {
      this.resetEmail()
      this.$emit('cancel')
    },
    /*
    resetEmail
    */
    resetEmail () {
      this.value = {
        ...this.value,
        send_type: 'immediately',
        send_at: null,
        cc: [],
        bcc: [],
        subject: '',
        body: '',
        attachments_media: []
      }
      this.validateErrors = false
      this.formsave.remove()
    },
    /*
    setTemplate
    */
    setTemplate (template) {
      this.$set(this.value, 'subject', template.subject)
      this.$set(this.value, 'body', template.body)
    },
    /*
    setSendAt
    */
    setSendAt (val) {
      this.$set(this.value, 'send_at', val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Email/EmailForm.vue